import { Navigate, useLocation } from 'react-router-dom'

/** Preserves React Router location.state when redirecting (e.g. email, applicationId). */
const RedirectWithState = ({ to }) => {
  const location = useLocation()
  return <Navigate to={to} state={location.state} replace />
}

export default RedirectWithState
